// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3s4oY","calendarButtons":"ClockData_calendarButtons__3dP6l"};